import { mkTrackAttrs } from '@/analytics/track';

const PREFIX = 'dragHandle' as const;

// table row drag handle
export const mkDragTableRowTrackAttrs = (props: {
  index: number;
  paperCorpusId?: number;
  visibleRows: number;
}) => mkTrackAttrs(`${PREFIX}__table_row`, props);

// table row drag handle
export const mkDragTableColTrackAttrs = (props: {
  index: number;
  columnName: string;
}) => mkTrackAttrs(`${PREFIX}__table_col`, props);
